<template>
    <div>
        <div class="header">
            <woot-tabs :index="selectedTabIndex" @change="onClickTabChange">
                <woot-tabs-item
                    v-for="tab in tabs"
                    :key="tab.key"
                    :name="tab.name"
                    :show-badge="false"
                />
            </woot-tabs>
        </div>


        <div class="row">
            <plan 
                v-if="selectedTabIndex == 0" 
                :integration="integration" 
            />

            <fipe 
                v-if="selectedTabIndex == 1" 
                :integration="integration"
            />
        </div>

    </div>
</template>

<script>
import ModalAddPlan from './ModalAddPlan.vue';
import Plan from './Plan.vue';
import Fipe from './Fipe.vue';
export default {
        components: {  ModalAddPlan, Plan, Fipe },
        name: 'Quotation',
        data() {
            return {
                selectedTabIndex: 0,
            };
        },
        props: {
            integration: {
                type: Object,
                default: () => ({}),
            },
        },

        computed: {
            tabs() {
                return [
                    {
                        key: 0,
                        name: this.$t('INTEGRATION_APPS.FIPE.TABS.QUOTATION_PLAN'),
                    },
                    {
                        key: 1,
                        name: this.$t('INTEGRATION_APPS.FIPE.TABS.FIPE'),
                    },
                ];
            },
        },


        methods: {
            onClickTabChange(index) {
                this.selectedTabIndex = index;
            },

        }
    }
</script>